import $ from 'jquery';
import '@zeitiger/elevatezoom/jquery.elevateZoom-3.0.8.min';
import 'slick-carousel';

function enableElevateZoom(img, config) {
    img.elevateZoom(config);
}

function disableElevateZoom(img) {
    $('.zoomContainer').remove();
    img.removeData('elevateZoom');
    img.removeData('zoomImage');
}

$(document).ready(function () {

    const zoomConfig = {
        zoomType: 'lens',
        lensShape: 'round',
        lensSize: 200,
        lensFadeIn: 250,
        lensFadeOut: 250,
        cursor: 'pointer',
        galleryActiveClass: 'slick-active',
        imageCrossfade: true,
        loadingIcon: 'images/ajax-loader.gif',
        containLensZoom: true
    };
    let slickSlider = $('.sliderDiapo');

    $(document).on('click', '.toggleZoom', ev => {
        const isEnabled = $(ev.currentTarget).hasClass('active');
        const btn = ev.currentTarget;
        const picture = $('.slick-current.slick-active img');

        const clickBtnFunc = () => {
            btn.click();
            slickSlider.off('beforeChange', clickBtnFunc);
            slickSlider.off('beforeChange', clickBtnFunc);
            picture.off('click', clickBtnFunc);
        };

        if (!isEnabled) {
            btn.classList.add('active', 'btn-bleuEM');
            $('.sliderDiapo').slick('slickPause');

            slickSlider.on('beforeChange', clickBtnFunc);
            picture.on('click', clickBtnFunc);
            enableElevateZoom(picture, zoomConfig);
        } else {
            ev.currentTarget.classList.remove('btn-bleuEM', 'active');
            disableElevateZoom(picture);
        }
    });
});
